import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchStarterInfoRequestedAction } from '../../../starters/actions/StartersActions';
import { getStartersGroupedByConnectionType } from '../../../starters/components/ConnectedStartersChannel';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { StartersSpace, StartersSpaceAngularProps, StartersSpaceDispatchProps, StartersSpaceOwnProps, StartersSpaceStateProps } from './StartersSpace';
import { errorBoundary, sendTelemetryErrorEvent } from '../../../common/react/components/ErrorBoundary';

const mapStateToProps: MapStateToProps<StartersSpaceStateProps> = (state: AppState) => ({
  startersGroupedByConnectionType: getStartersGroupedByConnectionType(state.starters.starters),
  isBusy: state.starters.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<StartersSpaceDispatchProps> = (dispatch) => bindActionCreators({
  fetchStartersData: fetchStarterInfoRequestedAction,
}, dispatch);

const ConnectedStartersSpaceInternal: React.ComponentClass<StartersSpaceOwnProps & StartersSpaceAngularProps>
  = connect(mapStateToProps, mapDispatchToProps)(StartersSpace);
export const ConnectedStartersSpace = errorBoundary<StartersSpaceOwnProps & StartersSpaceAngularProps>(sendTelemetryErrorEvent)(ConnectedStartersSpaceInternal);

